import { Box, Button,CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, Grid, MenuItem, Select, TextField, Typography} from '@mui/material';
import React, { useState, useEffect } from 'react';
import {control, Controller, useForm} from 'react-hook-form';
import Swal from 'sweetalert2';
import { BannerServices } from '../BannerServices';

const AddEditCategory = ({onClose}) => {
    // const { onClose , selectedBannerData} = props;
    const [pageTitle, setPageTitle] = useState('Add New Banner Category');
    const bannerCategoryInitialData = {
        title:'',
    }
    const [bannerCategory, setBannerCategory] = useState(bannerCategoryInitialData);
    const {control, handleSubmit, reset, formState:{isDirty}} = useForm({
        mode: 'onSubmit',
        defaultValues: bannerCategory,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const onSubmit = async(data) => {
        console.log(data);
        setIsSubmitting(true);
        try{            
            const createResponse = await BannerServices.addBannerCategory(data);
            if(createResponse.success == '1'){
                const result = await Swal.fire({
                    title: 'Success',
                    text: createResponse.message,
                    icon: 'success',
                    // button for add new or cancel on click cancel redirect to list page
                    showCancelButton: true,
                    confirmButtonText: 'Add New',
                    cancelButtonText: 'Close',
                    confirmButtonColor: '#4caf50',
                    cancelButtonColor: '#d33',
                });
                if(result.isConfirmed){
                    reset(bannerCategoryInitialData);
                }
                if (result.dismiss === Swal.DismissReason.cancel) {
                    onClose();
                }
            }else{
                Swal.fire({
                    title: 'Error',
                    text: createResponse.message || 'Something went wrong',
                    icon: 'error',
                    confirmButtonColor: '#4caf50',
                });
            }
        }catch(err){
            console.log(err);
        }finally{
            setIsSubmitting(false);
        }

    }
    // useEffect(() => {
    //     if(selectedBannerData && selectedBannerData?.id>0){
    //         setPageTitle('Edit Banner Section');
    //         setBannerCategory(selectedBannerData);
    //         reset(selectedBannerData,{isDirty:false});
    //     }
    // }, [selectedBannerData]);
  return (
    <Box>
        <Box sx={{display:'flex',justifyContent:'space-between',alignItems:'center',p:'1%',borderBottom:'1px solid #ccc'}}>
            <Typography sx={{fontSize:'0.85rem',fontWeight:600}} > {pageTitle} </Typography>
            <Button disabled={isSubmitting} size='small' variant='outlined' color='error' onClick={onClose}>Close</Button>
        </Box>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{p:'2%'}}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box sx={{display:'flex',alignItems:'center',gap:1,flexGrow:1}}>
                        <Typography sx={{fontSize:'0.85rem',fontWeight:600,width:'30%'}}>Banner Category <Box component={'span'} sx={{color:'#d32f2f'}}>*</Box></Typography>
                        <Controller
                            name="title"
                            control={control}
                            rules={{ required: 'Enter Banner Category title' }}
                            render={({field,fieldState:{error}}) => (
                                <TextField
                                    {...field}
                                    inputProps={{
                                        style:{
                                            fontSize:'0.75rem'
                                        }
                                    }}
                                    size='small'
                                    fullWidth
                                    error={!!error}
                                />
                            )}
                        />
                        {isSubmitting && <CircularProgress size={20} />}
                    </Box>
                    
                </Grid>
                <Grid item xs={12} sx={{display:'flex',justifyContent:'flex-end',gap:1}}>
                    <Button disabled={isSubmitting} size='small' variant='outlined' color='error' onClick={onClose}>Cancel</Button>
                    <Button disabled={isSubmitting || !isDirty} size='small' variant='contained' color='primary' type='submit'>{isSubmitting?'please wait...':'save'}</Button>
                </Grid>
            </Grid>
        </Box>
    </Box>
  );
}

export default AddEditCategory;
